import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { getDataWithStudent } from '../../../../lib/courselesson'

export default function Courses({ slug }) {
	const [lessons, setLessons] = useState([])

	const getGradeColor = (grade) => {
		if (grade >= 90) return '#007bff'
		if (grade >= 80) return '#28a745'
		if (grade >= 70) return '#ffc107'
		if (grade >= 65) return '#fd7e14'
		return '#dc3545'
	}

	const getCreditColor = (credit) => {
		if (credit >= 10) return '#6f42c1'
		if (credit >= 7.5) return '#20c997'
		if (credit >= 5) return '#17a2b8'
		if (credit >= 2.5) return '#ffc107'
		return '#e83e8c'
	}

	const getAPScoreColor = (score) => {
		if (score === 5) return '#007bff'
		if (score === 4) return '#28a745'
		if (score === 3) return '#ffc107'
		if (score === 2) return '#fd7e14'
		return '#dc3545'
	}

	const customStyles = {
		headCells: {
			style: {
				fontSize: '16px',
				fontWeight: 'bold',
				textTransform: 'uppercase',
				backgroundColor: '#f8f9fa'
			}
		},
		rows: {
			style: {
				minHeight: '60px', // Satır yüksekliği
				fontSize: '15px'
			}
		},
		cells: {
			style: {
				paddingTop: '16px',
				paddingBottom: '16px',
				fontSize: '15px'
			}
		}
	}

	const columns = [
		// { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
		{
			name: 'Year',
			selector: (row) => row.courseyear,
			sortable: true,
			width: '100px'
		},

		{
			name: 'Department',
			selector: (row) => row.department,
			sortable: true,
			width: '170px'
		},
		{ name: 'Course', selector: (row) => row.coursename, sortable: true },
		{ name: 'Level', selector: (row) => row.level, sortable: true },
		{
			name: 'Grade',
			cell: (row) => (
				<span
					className="badge"
					style={{
						backgroundColor: getGradeColor(row.grade),
						color: 'white',
						padding: '4px 8px',
						borderRadius: '6px',
						fontSize: '0.85rem'
					}}
					title={`Grade: ${row.grade}`}
				>
					{row.grade}
				</span>
			)
		},

		{
			name: 'Credit',
			cell: (row) => (
				<span
					className="badge"
					style={{
						backgroundColor: getCreditColor(row.credit),
						color: 'white',
						padding: '4px 8px',
						borderRadius: '6px',
						fontSize: '0.85rem'
					}}
					title={`Credit: ${row.credit}`}
				>
					{row.credit}
				</span>
			)
		},
		{
			name: 'AP Grade',
			cell: (row) => (
				<span
					className="badge"
					style={{
						backgroundColor: getAPScoreColor(row.apscore),
						color: 'white',
						padding: '4px 8px',
						borderRadius: '6px',
						fontSize: '0.85rem'
					}}
					title={`AP Score: ${row.apscore}`}
				>
					{row.apscore}
				</span>
			)
		},
		{
			name: 'GPA Calc',
			selector: (row) => (row.isgpacalc ? 'Yes' : 'No'),
			sortable: true
		}
	]

	const getData = async () => {
		const lesson = await getDataWithStudent(slug)
		setLessons(lesson)
	}

	useEffect(() => {
		getData()
	}, [])

	return (
		<div className="col-12">
			<div className="settings-widget profile-details">
				<div className="settings-inner-blk p-2">
					<div className="d-flex p-1 justify-content-between align-items-center">
						<h3>Lessons</h3>
					</div>
					<div className="comman-space pb-0">
						<DataTable columns={columns} data={lessons} highlightOnHover striped responsive dense persistTableHead customStyles={customStyles} />
					</div>
				</div>
			</div>
		</div>
	)
}
